export default __webpack_public_path__ + "static/media/fr.9e329b0f.svg";